module.exports = __webpack_public_path__ + "img/Loading_r_43.593ac95a.png";